<template>
  <div class="form">
    <h3>{{ service ? $t('randevu.services.add.title_edit') : $t('randevu.services.add.title_new') }}</h3>

    <input v-model="form.name" :placeholder="$t('randevu.services.add.name_placeholder')">
    <p v-if="validationErrors.name" class="error">{{ validationErrors.name }}</p>

    <textarea v-model="form.description" :placeholder="$t('randevu.services.add.description_placeholder')"></textarea>

    <div class="grid">
      <input type="number" v-model.number="form.duration" :placeholder="$t('randevu.services.add.duration_placeholder')">
      <input type="number" step="0.01" v-model.number="form.price" :placeholder="$t('randevu.services.add.price_placeholder')">
      <select v-model.number="form.currency_id">
        <option :value="1">₺</option>
        <option :value="2">$</option>
        <option :value="3">€</option>
      </select>
    </div>

    <div class="actions">
      <button class="primary" @click="submit">{{ service ? $t('randevu.services.add.update') : $t('randevu.services.add.add') }}</button>
      <button @click="$emit('close')">{{ $t('randevu.services.add.cancel') }}</button>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

export default {
  props: { service: Object },
  setup(props, { emit }) {
    const { t } = useI18n();
    const blank = { name: "", description: "", duration: null, price: null, currency_id: 1 };
    const form = ref(props.service ? { ...props.service } : { ...blank });
    const error = ref(null);
    const validationErrors = ref({});

    const validateForm = () => {
      validationErrors.value = {};
      if (!form.value.name || form.value.name.trim() === "") {
        validationErrors.value.name = t("randevu.services.add.name_required");
        return false;
      }
      return true;
    };

    const submit = async () => {
      if (!validateForm()) return;

      try {
        if (props.service) {
          await axios.put(`/promo/user/my-services/${props.service.id}`, form.value);
        } else {
          await axios.post("/promo/user/my-services", form.value);
        }
        emit("refresh");
        emit("close");
      } catch {
        error.value = t("randevu.services.add.generic_error");
      }
    };

    return { form, error, validationErrors, submit };
  }
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 4rem;
}
input,
textarea,
select {
  width: 100%;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}
.actions {
  display: flex;
  gap: 8px;
}
.primary {
  background: #106E35;
  color: #fff;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
}
.error {
  color: #f44336;
  font-size: 1em;
}
</style>
